import {
  Box,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import React from "react";

interface RefundStatusViewProps {
  refunds: any[];
}

export const RefundStatusView = ({ refunds }: RefundStatusViewProps) => {
  if (!refunds || refunds.length === 0) {
    return (
      <Box sx={{ p: 2, textAlign: "center" }}>
        <Typography variant="body2" color="text.secondary">
          No refund history for this session
        </Typography>
      </Box>
    );
  }

  const getStatusColor = (status: string) => {
    switch (status) {
      case "PENDING":
        return "warning";
      case "PROCESSING":
        return "info";
      case "COMPLETED":
        return "success";
      case "FAILED":
        return "error";
      default:
        return "default";
    }
  };

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Amount</TableCell>
            <TableCell>Reason</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Refund Ref</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {refunds.map((refund) => (
            <TableRow key={refund.id}>
              <TableCell>
                {moment(refund.created_at).format("DD-MM-YYYY, hh:mm A")}
              </TableCell>
              <TableCell>
                {refund.currency} {refund.amount}
              </TableCell>
              <TableCell>{refund.reason || "N/A"}</TableCell>
              <TableCell>
                <Chip
                  label={refund.status}
                  color={getStatusColor(refund.status)}
                  size="small"
                />
              </TableCell>
              <TableCell>{refund.refund_ref || "Pending"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
